export default __webpack_public_path__ + "static/media/contact-1.5a2e06c6.png";